import * as React from 'react';

import { connect, useDispatch } from 'react-redux';

import { Translate } from 'react-localize-redux';

import AppState from '@webapp/store/state';
import { LoginUser } from '@webapp/store/auth/action-creators';
import {
  LOGIN_USER_ERROR,
  LOGIN_USER,
  LOGIN_USER_ERROR_GOOGLE,
} from '@webapp/store/auth/actions';

import BasicAccountData from '@webapp/types/auth/basic-account-data';

import { SocialAuthCtrl } from '@webapp/controllers/registration/social-auth';
import EmailPasswordCtrl from '@webapp/controllers/registration/email-password';

import MotionOpacity from '@components/motion/motion-opacity';
import { ErrorMessage } from '@components/basics/error-message';

interface LoginPageProps {
  loginFailed?: string;
  isLoading: boolean;
  googleError?: string;
}

const mapStateToProps = (state: AppState) => ({
  loginFailed: state.ui.errors[LOGIN_USER_ERROR],
  isLoading: !!state.ui.loading[LOGIN_USER],
  googleError: state.ui.errors[LOGIN_USER_ERROR_GOOGLE],
});

const LoginFormPage: React.FC<LoginPageProps> = (props) => {
  const dispatch = useDispatch();
  const handleLogin = (data: BasicAccountData) => {
    dispatch(new LoginUser(data));
  };

  return (
    <MotionOpacity>
      <EmailPasswordCtrl
        screen="login"
        onSubmit={handleLogin}
        action={
          props.isLoading ? (
            <Translate id="REGISTER.BUTTON.LOGIN" />
          ) : (
            <Translate id="REGISTER.BUTTON.LOGININ" />
          )
        }
        errorKey={LOGIN_USER_ERROR}
        error={props.loginFailed}
        isLoading={props.isLoading}
        enablePhone={true}
      />
      {props.googleError && (
        <ErrorMessage
          hasBackground
          className="mt-20 mb-20"
          errorId={props.googleError}
        />
      )}
      <SocialAuthCtrl label={<Translate id="AUTH.LOGIN.SOCIAL" />} />
    </MotionOpacity>
  );
};

export default connect(mapStateToProps)(LoginFormPage);
